import { useRootLoaderData } from 'components/Root.loader'
import { format, differenceInDays } from 'date-fns'
import { useAlert } from 'hooks/useDialog'
import { useLayoutEffect } from 'react'

import { getLastLoginTime, setLastLoginTime } from './lastLoginStorage'

const checkAndSetLastLogin = () => {
  const lastLogin = getLastLoginTime()
  if (!lastLogin || differenceInDays(new Date(), lastLogin) >= 1) {
    setLastLoginTime()
    return false
  }

  return true
}

const trailRemainingMessage = (remaining: number, ending: Date) => {
  const endDateStr = format(ending, 'yyyy年MM月dd日')

  return [
    'OCR Readerトライアルをご利用ありがとうございます',
    remaining < 1
      ? '本日でトライアル利用期間が終了となります'
      : `トライアル終了まで ${remaining}日`,
    `(終了日：${endDateStr})`,
  ]
}

const TrialDateCheck = () => {
  const userProfile = useRootLoaderData().profile
  const alert = useAlert()

  useLayoutEffect(() => {
    const trialEnd = userProfile.trialEndDate ? new Date(userProfile.trialEndDate) : null

    if (trialEnd === null) {
      return
    }
    const today = new Date()

    if (!checkAndSetLastLogin()) {
      const remaining = differenceInDays(trialEnd, today)
      const message = trailRemainingMessage(remaining, trialEnd)
      alert({ message })
    }
  }, [alert, userProfile])

  return null
}

export default TrialDateCheck
